module.exports = __webpack_public_path__ + "static/media/EHallCorner-c.652bffaa.webp";